import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Skeleton,
  Box,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AWS from 'aws-sdk';
import awsConfig from '../../cfg/aws-config.json';
import PdfViewer from './PDFViewer.js';
import { getCaseS3Credentials } from '../../api/cases3credentials.js';
import {useGetCaseS3ObjectUrl} from "../../api/caseS3object.js";

export default function ViewStatementDialog(props) {
  // const [url, setUrl] = useState(null);
  // const [isLoading, setIsLoading] = useState(true);
  // const [error, setError] = useState(null);

  const parentOnCancel = props.onCancel || (() => {});
  const documentToView = props.documentToView;
  const highlightedTxn = props.highlightedTxn;
  const scanVariant = props.scanVariant || 'Ocrolus';

  console.log('highlightedTxn in ViewStatementDialog:', highlightedTxn);

  const viewerBbox = highlightedTxn?.bbox;
  const pageNumber = Number(highlightedTxn ? (highlightedTxn.page_number || highlightedTxn.start_page) : 1);
  const title = props.title || `View Document ${documentToView?.documentName || ''}`;

  const handleCancel = () => {
    parentOnCancel();
  };

  const { data: url, error, isLoading } = useGetCaseS3ObjectUrl(documentToView?.bucketName, documentToView?.objectKey, !!documentToView?.objectKey);


  console.log(
    `Rendering ViewStatementDialog with url=${url}, highlightedTxn=${JSON.stringify(highlightedTxn)}, pageNumber=${pageNumber}, viewerBbox=${JSON.stringify(viewerBbox)}`
  );

  return (
    <Dialog
      open={props.open}
      onClose={handleCancel}
      maxWidth="xl"
      fullWidth
    >
      <DialogTitle>
        {title}
        <IconButton
          aria-label="close"
          onClick={handleCancel}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          height: '80vh',
          width: '100%',
          p: 0,
        }}
      >
        {isLoading ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              gap: 2,
              p: 3,
            }}
          >
            <Skeleton variant="rectangular" width="100%" height="80%" />
            <Box sx={{ width: '100%', display: 'flex', gap: 1 }}>
              <Skeleton variant="rectangular" width="60%" height={40} />
              <Skeleton variant="rectangular" width="20%" height={40} />
              <Skeleton variant="rectangular" width="20%" height={40} />
            </Box>
            <Typography variant="body2" color="text.secondary">
              Loading document...
            </Typography>
          </Box>
        ) : error ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              gap: 2,
              p: 3,
            }}
          >
            <Typography variant="h6" color="error">
              Error Loading Document
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {error}
            </Typography>
          </Box>
        ) : url ? (
          <PdfViewer
            url={url}
            transactionSearch={{
              descr: highlightedTxn?.description || null,
              amount: highlightedTxn?.amount || null,
              posting_date: highlightedTxn?.posting_date || null,
            }}
            displayPage={pageNumber}
            boundingBox={viewerBbox}
            documentName={documentToView?.documentName || null}
          />
        ) : (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
            }}
          >
            <Typography variant="body1" color="text.secondary">
              No document to display
            </Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}